// extracted by mini-css-extract-plugin
export default {"list":"tags-module__list--RbRNS","img":"tags-module__img--V5xPT"};